import { createApp, h } from 'vue';
import * as Sentry from '@sentry/vue';
import Toast from 'vue-toastification';
import VueTippy from 'vue-tippy';
import { createVfm } from 'vue-final-modal';
import { VueQueryPlugin } from '@tanstack/vue-query';
import App from './App.vue';
import router from './router';
import { pinia } from './plugins/pinia';
import './styles/tailwind.css';
import { options as toastOptions } from './plugins/Toast';
import { appProgressLoader } from './plugins/AppProgressLoader';
import { plausible } from './plugins/plausible/setup';
import './styles/markdown.css';
import '@/lib/sortablejs';
import i18n from './i18n';

const app = createApp({
	render: () => h(App),
});

Sentry.init({
	app,
	debug: process.env.NODE_ENV !== 'production',
	dsn: 'https://ea89099b8f2ee2ac87378c37419f2057@o4509711156707333.ingest.de.sentry.io/4509807441412176',
	integrations: [
		Sentry.browserTracingIntegration(),
		Sentry.replayIntegration(),
	],
	allowUrls: ['netlify.app', 'sunhealth.io', /^\//],
	environment: import.meta.env.MODE,
	release: __COMMIT_REF__,
	tracePropagationTargets: ['netlify.app', /^\//],
	tracesSampleRate: 1.0,
	replaysSessionSampleRate: 0.1,
	replaysOnErrorSampleRate: 1.0,
});

app.use(createVfm());

app.use(VueTippy, {
	directive: 'tippy',
	defaultProps: {
		placement: 'bottom',
		theme: 'sunhealth',
		animation: 'shift-toward',
	},
});

app.use(i18n);
app.use(router);
app.use(appProgressLoader, { router });
app.use(pinia);
app.use(Toast, toastOptions);
app.use(plausible);
app.use(VueQueryPlugin);

app.mount('#app');
